import axios from 'axios'
import dayjs from 'dayjs'
import { useContext, useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { CongratulatoryCardContext } from 'src/consumer/context/CongraulatoryCardContext'
import { InformationContext } from 'src/consumer/context/InformationContext'
import { JournalContext } from 'src/consumer/context/JournalContext'
import { PlayerContext } from 'src/consumer/context/PlayerContext'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { getDataWithoutParams } from 'src/consumer/services/featureServices'
import { getData } from 'src/consumer/services/profileService'
import { hasCompletedConsumerOnboarding } from 'src/consumer/helpers/onboardingStatus'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'
import { SetupContext } from '../../context/SetupContext'
import { getTabOrder, getTabsListMap } from '../../helpers/tabDataHelper'
import { apiURL } from '../../services/index'
import { RedirectStrip, RedirectStripButton } from '../BlockerScreens/RedirectStyles'
import CongratulatoryCard from '../CongratulatoryScreen'
import CoursePlayer from '../CourseCards/CoursePlayer'
import { GenericInformationModal } from '../GenericInformationModal'
import GlobalNav from '../GlobalHeader/GlobalNav'
import Journal from '../Journal'
import { LoadingSpinner } from '../Loaders'
import PrewallAndPaywall from '../PrewallAndPaywall/PrewallAndPaywall'
import { FlowSelectionComponent } from './FlowSelectionModern'
import { StyledComsumerContainer } from './ConsumerHomepageStyle'

const ConsumerHomepage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { state } = location
  const isRootPath = location.pathname === '/' || location.pathname === ''
  const showPrewallOnHome = state?.showPrewallOnHome

  const prewallData = {
    content_play: {
      id: 'content_play',
      toggleFunction: () => {
        setIsCommonPrewallOpen((prev) => !prev)
      },
    },

    journal_play: {
      id: 'journal_play',
      toggleFunction: () => {
        setIsCommonPrewallOpen((prev) => !prev)
      },
    },

    free_trial_box_tap: {
      id: 'free_trial_box_tap',
      toggleFunction: () => {
        setIsCommonPrewallOpen((prev) => !prev)
      },
    },

    upgrade_btn: {
      id: 'upgrade_btn',
      toggleFunction: () => {
        setIsCommonPrewallOpen((prev) => !prev)
      },
    },
  }

  const { unSecureSetupLoading, unSecureSetupData, unSecureSetupError } =
    useContext(UnsecureSetupContext)
  const { setupLoading, setupData, setupError } = useContext(SetupContext)

  const [pageState, setPageState] = useState()

  useEffect(() => {
    if (setupData) {
      localStorage.setItem('metaMoods', JSON.stringify(setupData?.metaMoods))
    }
  }, [setupData])

  const { profileData, setProfileData } = useContext(ProfileContext)
  const { informationModalData, setInformationModalData } = useContext(InformationContext)

  const [playerData, setPlayerData] = useState({
    showPIP: false,
    showLeavingEarly: false,
    showPlayer: false,
    selectedCard: '',
    showCompletionFeedback: false,
    source: '',
    id: '',
    otherData: {},
  })
  const [journalData, setJournalData] = useState({
    showJournal: false,
    callSource: '',
    data: '',
    pageState: '',
    subscription: '',
  })
  const [congratulatoryCardData, setCongratulatoryCardData] = useState({
    showCard: false,
    data: {},
  })

  const [isPreAndPaywallOpen, setIsPreAndPaywallOpen] = useState(showPrewallOnHome || false)
  const [isCommonPrewallOpen, setIsCommonPrewallOpen] = useState(false)

  const [timeSlotsData, setTimeSlotsData] = useState({})
  const [userFavoriteData, setUserFavoriteData] = useState({})
  const [completionData, setCompletionData] = useState([])
  const [commonPrewallData, setCommonPrewallData] = useState('')
  const [bookedSlotsDataPageOne, setBookedSlotsDataPageOne] = useState([])
  const [userScoreData, setUserScoreData] = useState([])
  const [oneOnOneMentorsData, setOneOnOneMentorsData] = useState([])

  const { tileId } = useParams()
  // ROLE_PATIENT users are now routed to the dedicated /patient-home/* portal
  // by loginHandoff and the navigates below; on the rare occasion they land on
  // ConsumerHomepage we just give them the regular wellness preselected tab
  // rather than the retired 'patient-home' tile.
  const defaultTab = getTabOrder(setupData)?.preselectedTab

  const selectedTileId = tileId || defaultTab

  useEffect(() => {
    ;(async () => {
      const response = await getData('/api/secure/user/booked-slots')
      if (response?.status === 200) {
        setBookedSlotsDataPageOne(response?.data)
      }
    })()
    ;(async () => {
      const response = await getData('/api/secure/user/points-profile')
      if (response?.status === 200) {
        setUserScoreData(response?.data)
      }
    })()
    ;(async () => {
      const response = await getData('/api/external/mentor/1on1/list')
      if (response?.status === 200) {
        setOneOnOneMentorsData(response?.data)
      }
    })()
  }, [])

  useEffect(() => {
    if (
      profileData?.subscriptionTypeId === 'subscription_free' &&
      playerData?.selectedCard !== '' &&
      playerData?.selectedCard?.course?.subscription?.id !== 'subscription_free'
    ) {
      setPlayerData({
        showPIP: false,
        showLeavingEarly: false,
        showPlayer: false,
        selectedCard: '',
        showCompletionFeedback: false,
        source: '',
        id: '',
      })
      setCommonPrewallData(prewallData?.['content_play'])
      setIsCommonPrewallOpen(true)
    }
  }, [playerData])

  useEffect(() => {
    if (
      profileData?.subscriptionTypeId === 'subscription_free' &&
      journalData?.showJournal === true &&
      journalData?.pageState === 'new_journal' &&
      journalData?.subscription !== 'subscription_free'
    ) {
      setJournalData({
        showJournal: false,
        callSource: '',
        data: '',
        pageState: '',
        subscription: '',
      })
      setCommonPrewallData(prewallData?.['journal_play'])
      setIsCommonPrewallOpen(true)
    }
  }, [journalData])

  async function setupTimeSlots() {
    const fetchTimeSlots = async () => {
      let data = await axios.get(`${apiURL}/api/timeslots`)
      return data
    }
    let timeSlotResponse = await fetchTimeSlots()
    if (timeSlotResponse.status === 200) {
      setTimeSlotsData(timeSlotResponse?.data)
    } else {
      console.log('error getting time slots')
    }
  }

  async function setupUserFavorites() {
    const fetchUserFavorites = async () => {
      let data = await getData('/api/secure/user/favorites')
      return data
    }
    let userFavoriteResponse = await fetchUserFavorites()
    if (userFavoriteResponse.status === 200) {
      setUserFavoriteData(userFavoriteResponse?.data)
    } else {
      console.log('error getting time slots')
    }
  }

  async function updateDailyPlayProgress() {
    const response = await getDataWithoutParams(
      `/api/secure/user/daily-play-streaks?zoneOffset=${encodeURIComponent(getTimezoneOffset())}`,
    )
    if (response.status === 200) {
      setCompletionData(response?.data)
    }
  }

  async function updateUserScoreData() {
    const response = await getData('/api/secure/user/points-profile')
    if (response?.status === 200) {
      setUserScoreData(response?.data)
    }
  }

  useEffect(() => {
    setupTimeSlots()
    updateDailyPlayProgress()
  }, []) //setting time slots

  useEffect(() => {
    setupUserFavorites()
  }, []) // setting user favorites

  useEffect(() => {
    // Portal-routing decisions used to live here too — auto-redirecting
    // support / kiosk / mentor / clinic / business users to their own
    // portals, mirroring the lastChosenFlow heuristic, etc. That logic
    // duplicated what `pickConsumerHomeForRoles` in
    // consumer/layout/ConsumerLayout.jsx → RootLanding already does on
    // every login + every / hit, and the duplication caused the
    // "control briefly flashes through /wellness on login" symptom
    // because RootLanding picked the portal and ConsumerHomepage then
    // re-picked it from inside AppHomepage's render tree.
    //
    // Single source of truth now:
    //   - Login + / route → RootLanding → pickConsumerHomeForRoles.
    //   - /wellness/* → WellnessHomeGate → bounces workforce-role
    //     visitors to their primary portal UNLESS they explicitly chose
    //     wellness this session (the portal-switcher's "Wellness app"
    //     onClick + the CareStatusView wellness-escape link set the
    //     explicitlyChoseConsumerPortal sessionStorage flag).
    //
    // By the time we're rendering inside ConsumerHomepage, the user
    // is on /wellness intentionally (or is a pure ROLE_USER). What's
    // left for us here: bootstrap the consumer experience —
    // set pageState='consumer', kick the deeper consumer-onboarding
    // wizard if the profile needs richer fields (persona / focus
    // areas / etc.), and remember the explicit-choice flag so a tab
    // refresh inside the same session doesn't bounce them back.
    if (localStorage.getItem('authorities')) {
      handleChoosingEndUserSide()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileData, setupData])

  function handleChoosingEndUserSide() {
    // Set flag to indicate user explicitly chose consumer portal
    sessionStorage.setItem('explicitlyChoseConsumerPortal', 'true')
    localStorage.removeItem('lastChosenFlow')
    setPageState('consumer')
    // The wellness portal doesn't special-case ROLE_PATIENT any more — patients
    // belong on /patient-home/* and loginHandoff routes them there at login.
    // If a multi-role patient lands here, they get the regular wellness flow
    // like any other user.
    if (profileData && !hasCompletedConsumerOnboarding(profileData)) {
      navigate('/onboarding', {})
    } else if (selectedTileId && canRedirectToTiles(window.location.pathname)) {
      navigate(`/tile/${selectedTileId}`)
    }
  }

  // The handleChoosing*Side dispatchers for CA / kiosk / mentor /
  // support / business were deleted along with the duplicate portal-
  // routing useEffect. RootLanding + WellnessHomeGate are the single
  // source of truth for portal routing now; this component only owns
  // the wellness shell after the gate has cleared the user through.

  if (unSecureSetupLoading || setupLoading) {
    return <LoadingSpinner />
  }

  function openPrewallFunction(prewallId) {
    setCommonPrewallData(prewallData?.[prewallId])
    setIsCommonPrewallOpen(true)
  }

  console.log(tileId)
  console.log(defaultTab)

  return (
    <CongratulatoryCardContext.Provider
      value={{ congratulatoryCardData, setCongratulatoryCardData }}
    >
      <PlayerContext.Provider value={{ playerData, setPlayerData }}>
        <JournalContext.Provider value={{ journalData, setJournalData }}>
          {/* prewalls :   */}

          <PrewallAndPaywall
            id="onboarding"
            secureData={setupData}
            wallIsOpen={isPreAndPaywallOpen}
            toggleWall={() => {
              setIsPreAndPaywallOpen((prev) => !prev)
              window.history.replaceState({}, '')
            }}
          />

          <PrewallAndPaywall
            id={commonPrewallData?.id}
            secureData={setupData}
            wallIsOpen={isCommonPrewallOpen}
            toggleWall={commonPrewallData?.toggleFunction}
          />

          {/* context components :  */}

          {playerData?.showPlayer && <CoursePlayer userFavoriteData={userFavoriteData} />}
          {journalData?.showJournal && <Journal />}
          {congratulatoryCardData?.showCard && <CongratulatoryCard />}
          {informationModalData?.showModal && <GenericInformationModal />}

          {/* UI :  */}

          {(pageState === 'flowSelection' || window.location.search.includes('showFlowSelection=true')) && (
            <FlowSelectionComponent
              showNormalUserView={() => {
                handleChoosingEndUserSide()
              }}
            />
          )}

          {pageState === 'consumer' && (
            <StyledComsumerContainer lightBg={false}>
              {unSecureSetupData?.clientType === 'mobileBrowser' &&
                showRedirectStrip(window.location.pathname) && (
                  <RedirectStrip>
                    Upgrade to smarter AUMHUM
                    <RedirectStripButton
                      onClick={() => (window.location.href = 'https://aumhum.page.link/app')}
                    >
                      OPEN
                    </RedirectStripButton>
                  </RedirectStrip>
                )}

              {showGlobalNav(window.location.pathname) && (
                <GlobalNav
                  tabOrder={getTabOrder(setupData)}
                  tabsListMap={getTabsListMap(setupData)}
                  activeTile={selectedTileId}
                  unSecureSetupData={unSecureSetupData}
                  isMobile={unSecureSetupData?.clientType === 'mobileBrowser'}
                  openPrewallFunction={() => openPrewallFunction('free_trial_box_tap')}
                  bookedSlotsDataPageOne={bookedSlotsDataPageOne}
                  userScoreData={userScoreData}
                />
              )}

              <Outlet
                context={{
                  selectedTileId,
                  timeSlotsData,
                  completionData,
                  openPrewallFunction,
                  userFavoriteData,
                  bookedSlotsDataPageOne,
                  updateUserScoreData,
                  oneOnOneMentorsData,
                }}
              />
            </StyledComsumerContainer>
          )}
        </JournalContext.Provider>
      </PlayerContext.Provider>
    </CongratulatoryCardContext.Provider>
  )
}

function showGlobalNav(locationPathName) {
  const noNavPages = [
    '/profile',
    '/leaderboard',
    '/my-live-sessions',
    '/live',
    '/my-plan',
    '/plan',
    '/my-activity',
  ]

  for (let page of noNavPages) {
    if (locationPathName.startsWith(page)) {
      return false
    }
  }

  return true
}

export function showRedirectStrip(locationPathName) {
  const noRedirectStripPages = [
    '/my-live-sessions',
    '/live',
    '/my-plan',
    '/my-activity',
    '/my-plan/create',
  ]
  for (let page of noRedirectStripPages) {
    if (locationPathName.startsWith(page)) {
      return false
    }
  }
  return true
}

function canRedirectToTiles(locationPathName) {
  const noRedirectPages = [
    '/profile',
    '/my-live-sessions',
    '/my-plan',
    '/my-activity',
    '/leaderboard',
    '/redeem',
    '/tile/practice',
  ]
  for (let page of noRedirectPages) {
    if (locationPathName.startsWith(page)) {
      return false
    }
  }
  return true
}

export default ConsumerHomepage
